import { render, staticRenderFns } from "./AttendanceStudent.vue?vue&type=template&id=52177f09&"
import script from "./AttendanceStudent.vue?vue&type=script&lang=js&"
export * from "./AttendanceStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports